import React from "react";
import { Link } from "react-router-dom";
import { websitePaths } from "../../routes/websitePaths";
import "../../components/website/sections/ProjectCategoryPage.css";

const safetyPillars = [
  {
    title: "Site Safety Planning",
    description:
      "Pre-start risk identification, protective measures, and structured site instructions before execution begins.",
  },
  {
    title: "Quality And Compliance Checks",
    description:
      "Routine inspections help ensure workmanship, materials, and procedures stay aligned with project requirements.",
  },
  {
    title: "Team Accountability",
    description:
      "Clear supervision, reporting discipline, and follow-through across contractors, vendors, and field teams.",
  },
];

const compliancePractices = [
  {
    title: "Daily Safety Briefings",
    location: "On-Site Operations",
    description:
      "Teams begin work with clear instructions on hazards, task sequencing, and protective expectations.",
    image:
      "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Material And Workmanship Audits",
    location: "Quality Assurance",
    description:
      "Regular reviews help catch deviations early and keep execution aligned with approved standards.",
    image:
      "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Documentation And Reporting",
    location: "Compliance Tracking",
    description:
      "Project records, checklists, and issue logs support transparency and measurable site control.",
    image:
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1200&q=80",
  },
];

const SafetyCompliancePage: React.FC = () => {
  return (
    <section className='project-category-page website-page'>
      <div className='project-category-hero website-page-hero text-center'>
        <div className='container'>
          <p className='website-page-kicker mb-2'>Safety And Compliance</p>
          <h2 className='project-page-title website-page-title mb-3'>
            Operational discipline designed to keep projects safe, reliable, and
            accountable.
          </h2>
          <p className='project-page-subtitle website-page-subtitle mx-auto mb-0'>
            Our teams follow structured site practices that support worker
            safety, quality checks, and clear compliance visibility throughout
            each project phase.
          </p>
        </div>
      </div>

      <div className='container website-page-content'>
        <div className='row g-3 mb-4'>
          {safetyPillars.map((item) => (
            <div className='col-md-4' key={item.title}>
              <div className='website-metric-card h-100'>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className='row g-4'>
          {compliancePractices.map((item) => (
            <div
              className='col-md-6 col-lg-4'
              key={`${item.title}-${item.location}`}
            >
              <article className='card project-show-card h-100 border-0'>
                <img
                  src={item.image}
                  alt={item.title}
                  className='card-img-top project-show-image'
                />
                <div className='card-body d-flex flex-column'>
                  <h5 className='card-title mb-2'>{item.title}</h5>
                  <p className='project-show-location mb-2'>
                    <i className='bi bi-shield-check me-2'></i>
                    {item.location}
                  </p>
                  <p className='card-text mb-3'>{item.description}</p>
                  <Link
                    to={websitePaths.contact}
                    className='btn brand-btn-outline mt-auto align-self-start'
                  >
                    Ask About Site Standards
                  </Link>
                </div>
              </article>
            </div>
          ))}
        </div>

        <div className='project-category-cta mt-4'>
          <div>
            <span className='website-section-kicker'>Project Governance</span>
            <h3 className='mb-2'>
              Want a team that keeps safety and quality visible from day one?
            </h3>
            <p className='mb-0'>
              Connect with us for project planning, execution controls, and
              practical site management support.
            </p>
          </div>
          <Link to={websitePaths.contact} className='btn brand-btn-primary'>
            Schedule A Discussion
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SafetyCompliancePage;


